import { I18n } from 'utils/i18n';

export function localizeReferenceDescription(item) {
  if (item?.kind === 'builtin') {
    return I18n.t(`AgenticChatFlow.BuiltinTools.${item.name}`, {
      defaultValue: item.description,
    });
  }
  return item?.description || '';
}

export function localizeReferenceKind(kind) {
  const keyByKind = {
    builtin: 'AgenticChatFlow.RefKindBuiltin',
    tool: 'AgenticChatFlow.RefKindTool',
    skill: 'AgenticChatFlow.RefKindSkill',
  };
  const key = keyByKind[kind] || keyByKind.tool;
  return I18n.t(key, { defaultValue: (kind || 'tool').toUpperCase() });
}
